// lib
import { assoc, isEmpty, map } from "ramda";
// src
import { PREFS_VERSION } from "config/constants";
import { isCategoryId } from "utils/presets";

// Note: adding version last in migrateToV1 ensures further patch will be accepted
// since the back-end will refuse prefs update with version
// in the meantime, if an error occurs while migrating, not adding the version set
// is a (kinda) security belt -> current server side prefs won't be overriden
// (but a fix will still be needed)
const migrateToV1 = (prefs) => {
  console.info(`[plannings] migrate prefs version to: ${PREFS_VERSION}`);
  const newById = map((preset) => {
    const { color } = preset;
    if (!color || color.startsWith("#")) return preset;
    return assoc("color", `#${color}`, preset);
  }, prefs.byId);
  return { ...prefs, byId: newById, version: PREFS_VERSION };
};

// Due to a previous bug where different categories could have the same ID, problematic states may remain in DB
// Relies on the fact that favorites are sorted vertically,
// each child belonging to the first category above it,
// and beeing on the ground floor if no category above it
const filterFavDuplicates = (prefs) => {
  if (!prefs || !prefs.favoriteIds || !Array.isArray(prefs.favoriteIds)) return prefs;
  const { favoriteIds } = prefs;
  const newFavoriteIds = [];
  const categoryIds = [];
  let currentCatChildrenIds = [];
  let rejectCat = false;
  for (const id of favoriteIds) {
    if (isCategoryId(id)) {
      currentCatChildrenIds = [];
      // is category
      if (categoryIds.includes(id)) {
        // is category with duplicate id
        rejectCat = true;
      } else {
        rejectCat = false;
        categoryIds.push(id);
        newFavoriteIds.push(id);
      }
    } else if (!rejectCat) {
      if (!currentCatChildrenIds.includes(id)) {
        currentCatChildrenIds.push(id);
        newFavoriteIds.push(id);
      }
    }
  }
  return { ...prefs, favoriteIds: newFavoriteIds };
};

export const migratePrefs = (prefs) => {
  if (!prefs || isEmpty(prefs)) return { version: PREFS_VERSION };
  const fixedPrefs = filterFavDuplicates(prefs);
  const { version } = fixedPrefs;
  if (version === PREFS_VERSION) return fixedPrefs;
  if (!version) return migrateToV1(fixedPrefs);
  return fixedPrefs;
};
